import { AGE_GROUP_OPTIONS } from '../utils/leaderboardConfig';
import './AgeGroupFilter.css';

const AgeGroupFilter = ({ value, onChange }) => (
  <div className="age-group-filter" role="group" aria-label="Filter by age group">
    {AGE_GROUP_OPTIONS.map((option) => (
      <button
        key={option.key || 'all'}
        type="button"
        className={`age-group-chip ${value === option.key ? 'active' : ''}`}
        aria-pressed={value === option.key}
        onClick={() => onChange(option.key)}
      >
        {option.label}
      </button>
    ))}
  </div>
);

export default AgeGroupFilter;
